<template>
  <td v-if="actions.length > 0" class="table-actions">
    <template v-for="(action, index) of actions">
      <template v-if="checkModule(action) && checkCreator(action) && checkAction(action, object)">
        <check-permission-for-exact-entity
          v-if="!action.forceNoEntity && !forceNotExact && action.entityId && action.entityType"
          :key="`action_exact_${object.id}_${action.id || action.event}`"
          :permissions="action.permissions || getPermissions(action.permissionTypes)"
          :permission-entity-id="action.entityId"
          :permission-entity-type="action.entityType"
          :role-entity-id="object.id"
          :role-entity-type="entityType"
        >
          <action :action="action" :object="object" v-on="$listeners" />
        </check-permission-for-exact-entity>

        <check-permission
          v-else
          :key="action.permissions + '_' + action.event + '_' + index"
          :entity-id="action.forceNoEntity ? undefined : action.entityId ? action.entityId : object[idKey]"
          :entity-type="action.forceNoEntity ? undefined : action.entityType ? action.entityType : entityType"
          :permissions="action.permissions ? action.permissions : getPermissions(action.permissionTypes)"
        >
          <action :action="action" :object="object" v-on="$listeners" />
        </check-permission>
      </template>
    </template>
  </td>
</template>

<script>
import { actionsMixin } from '@/mixins/actions';

import Action from './Action.vue';

// @vuese
// Akcje tabeli
// @group Table
export default {
  name: 'TActions',
  components: { Action },
  mixins: [actionsMixin],
  props: {
    // Klucz identyfikatora
    idKey: { type: String, required: false, default: 'id' },

    // Czy wymuszać sprawdzanie uprawnień "po staremu" - bez dokładnej encji
    forceNotExact: { type: Boolean, default: false }
  },
  methods: {
    // @vuese
    // Sprawdza, czy akcja powinna być widoczna
    checkAction(action, object) {
      if (action && action.check) {
        if (typeof action.check === 'string') {
          action.check = new Function('object', 'action', action.check);
        }
        return action.check(object, action);
      }
      return true;
    }
  }
};
</script>
